export default __webpack_public_path__ + "static/media/token1.3fd16f30.png";